import React, { useEffect, useState } from "react";

import Typewriter from "typewriter-effect";
// import logo from "../../assets/";
// import image1 from "../../assets/loading-title.svg";
// import image2 from "../../assets/scroll-new.gif";
// import headline from "../../assets/headline.svg";
// import circleS from "../../assets/code-circle-s.svg";
// import circleM from "../../assets/code-circle-m.svg";
// import circleL from "../../assets/code-circle-l.svg";
// import heroAvatar from "../../assets/hero-avatar.png";

function Home(props) {
  const [style, setStyle] = useState();
  const scaleOnScroll = () => {
    const scrollPosition = window.scrollY;
    const pos = scrollPosition / 250;
    var val = 0.5;
    if (pos >= 1.5) {
      val = 1.5;
    } else if (pos <= 0.5) {
      val = 0.8;
    } else {
      val = pos;
    }
    const opacity = scrollPosition / 100;
    // setStyle("scale-[" + val * 2 + "]; opacity:" + (1 - opacity / 6) + ";");
    setStyle({
      opacity: 1 - opacity / 5,
      transform: `scale(${val * 2})`,
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", scaleOnScroll);
    return () => window.removeEventListener("scroll", scaleOnScroll);
  }, []);
  return (
    <div className="w-full  h-[90vh] ">
      <div className="w-full h-[90vh] flex flex-col items-center text-center">
        <h1
          style={style}
          className={`text-white text-center md:text-[150px] items-center m-auto text-2xl fixed  top-[40%] right-0 left-0 right-0`}
        >
          Gele
        </h1>
        <div
          style={style}
          className="fixed top-[60%] right-0 mt-5 left-0 right-0"
        >
          {" "}
          <Typewriter
            options={{
              strings: ["Welcome to", "Gele Collection Project"],
              autoStart: true,
              loop: true,
            }}
          />
        </div>
      </div>
      <div className="flex justify-center">
        {/* <button
          style={style}
          className="btn main-btn bg-[#4753d6] px-[10px] py-[15px] text-white font-bold"
        >
          View on Opensea
        </button> */}
      </div>
      {/* <div id="chevron" className="w-full"></div> */}
    </div>
  );
}

export default Home;
